import { ServicesContent } from "@components/pages/services/services-content"
import { ServicesCover } from "@components/pages/services/services-cover"
import ServicesStarNow from "@components/pages/services/services-start-now"
import { ServicesTab } from "@components/pages/services/services-tab"
import { getPageBySlug } from "lib/api"
import { metaDesc } from "src/helper/meta-desc"
import { translations } from "src/helper/translations"
import { convertJson, extractMeta } from "src/mixins"

function ProductsServicesDetailPage({ data, locale, slug }) {
  const tab = slug || "studio-booking"
  const pageData = data?.meta
  const cover = extractMeta(pageData, "hero")
  const content = extractMeta(pageData, "features")
  // const movies = extractMeta(pageData, "movies")
  const startNow = extractMeta(pageData, "start_now")
  return (
    <>
      <ServicesTab tab={tab} locale={locale} />
      <ServicesCover data={cover} locale={locale} />
      {convertJson(content?.items)?.map((item, i) => (
        <ServicesContent
          key={`services-content-${slug}-${i}`}
          data={item}
          locale={locale}
          alt={(i + 1) % 2 === 0}
        />
      ))}
      <ServicesStarNow data={startNow} locale={locale} tab={tab} />
    </>
  )
}
export default ProductsServicesDetailPage

export async function getStaticPaths() {
  const services = ["studio-booking", "advertising", "promotion"]
  const routesId = services?.map((item) => ({
    params: { slug: item },
    locale: "id",
  }))
  const routesEn = services?.map((item) => ({
    params: { slug: item },
    locale: "en",
  }))
  return { paths: [...routesEn, ...routesId], fallback: false }
}

export async function getStaticProps(ctx) {
  const { locale } = ctx
  const { slug } = ctx.params
  const data = await getPageBySlug(slug)
  const titleDescMapping = () => {
    switch (slug) {
      case "studio-booking":
        return {
          title: translations[`studio_booking_${locale}`],
          description: metaDesc[`studio_booking_${locale}`],
        }
      case "advertising":
        return {
          title: translations[`advertising_${locale}`],
          description: metaDesc[`advertising_${locale}`],
        }
      case "promotion":
        return {
          title: translations[`promotion_${locale}`],
          description: metaDesc[`promotion_${locale}`],
        }
      default:
        return { title: translations[`services_${locale}`], description: "" }
    }
  }
  return {
    props: {
      seo: {
        title: titleDescMapping().title,
        description: titleDescMapping().description,
      },
      page: "Services",
      theme: "white",
      locale,
      data,
      slug,
    },
    revalidate: 60,
  }
}
